<template>
  <div>
    <Logo
      id="print-logo"
      style="
        position: fixed;
        text-align: center;
        top: 25%;
        left: 50%;
        padding: 20px;
        transform: translate(-50%, 0);
        opacity: 0.1;
        z-index: 9999;
      "
      width="600"
    ></Logo>
    <loading
      v-if="getAuthorizeStatus === 'loading'"
      :message="$t('authorize.loading')"
    ></loading>
    <div v-else-if="getAppLoaded && getDefaultLayoutLoaded" class="l-default">
      <Sidebar
        @click:profile="$refs.header.showUpdateAdmin = true"
        ref="sidebar"
        class="l-default__sidebar"
      />
      <div class="l-default__content">
        <div>
          <Header
            ref="header"
            @click:menu="$refs.sidebar.show()"
            class="l-default__content__header"
          />
          <LockedView
            v-if="
              !pageMeta.roles.includes(getActiveUser.userInfo.role) &&
              !pageMeta.roles.includes(
                `DepartmentRole${
                  getActiveUser.userInfo?.departmentUserRole || ''
                }`
              )
            "
          >
            <div>
              {{ $t("common.lockedViewText") }}
            </div>
            <div class="u-margin-top">
              <router-link :to="{ name: 'home' }">
                <Button variant="primary">
                  <i class="icofont-home"></i> {{ $t("navigation.home") }}
                </Button>
              </router-link>
            </div></LockedView
          >
          <main class="l-default__content__body" v-else>
            <DownloadProgress />
            <transition
              enter-active-class="page-open"
              leave-active-class="page-leave"
              mode="out-in"
            >
              <router-view />
            </transition>
          </main>
          <MobileMenu />
          <Footer class="l-default__content__footer" />
        </div>
      </div>
    </div>
    <PageLoading v-else />
  </div>
</template>

<script>
import Sidebar from "@shared/Sidebar/index.vue";
import Header from "@shared/Header/index.vue";
import Footer from "@shared/Footer/index.vue";
import MobileMenu from "@shared/MobileMenu/index.vue";
import auth from "../mixins/auth";
import Logo from "@/components/Shared/Sidebar/Logo.vue";
import LockedView from "@/components/LockedView/index.vue";
import Button from "@/components/Base/Button.vue";
import DownloadProgress from "@/components/FileManager/DownloadProgress.vue";
import { mapGetters } from "vuex";
export default {
  mixins: [auth],
  computed: {
    ...mapGetters([
      "getDefaultLayoutLoaded",
      "getActiveUser",
      "getAuthorizeStatus",
    ]),
    pageMeta() {
      return this.$route.meta || { roles: [] };
    },
  },
  components: {
    Footer,
    Header,
    Sidebar,
    MobileMenu,
    Logo,
    LockedView,
    Button,
    DownloadProgress,
  },

  methods: {
    async StartApp() {
      if (!this.getActiveUser.token) return;
      this.$store.commit("SET_APP_LOADED", true);
      this.$store.commit("SET_DEFAULT_LAYOUT_LOADED", true);
      await this.$store.dispatch("GET_AUTHORIZE_LIST");
    },

    setupPrintListener() {
      window.addEventListener("beforeprint", (event) => {
        event.preventDefault();

        // Tüm butonları seç ve opacity:0 uygula
        const buttons = document.querySelectorAll("button");
        buttons.forEach((button) => {
          button.style.opacity = "0";
        });

        const header = document.querySelector("header");
        header.style.display = "none";
        const main = document.querySelector("main");
        main.style.height = "auto";
        main.style.overflow = "visible";

        const menus = document.querySelectorAll("nav");
        menus.forEach((menu) => {
          menu.style.visibility = "hidden";
        });
        const tabs = document.querySelector(".c-tabs__headers");
        tabs.style.display = "none";

        const printLogo = document.getElementById("print-logo");
        printLogo.style.display = "block";

        const startsWithEsClass = document.querySelectorAll(".es-");
        startsWithEsClass.forEach((element) => {
          element.style.width = "100% !important";
        });

        // Kısa bir gecikme sonrası yazdırma işlemini başlat
        setTimeout(() => {
          window.print();
        }, 100);
      });

      // Yazdırma işlemi bittiğinde butonları eski haline getir
      window.addEventListener("afterprint", () => {
        const buttons = document.querySelectorAll("button");
        buttons.forEach((button) => {
          button.style.opacity = "1";
        });

        const header = document.querySelector("header");
        header.style.display = "flex";

        const main = document.querySelector("main");
        main.style.height = "calc(100vh - 120px)";
        main.style.overflow = "scroll";

        const menus = document.querySelectorAll("nav");
        menus.forEach((menu) => {
          menu.style.visibility = "visible";
        });

        const tabs = document.querySelector(".c-tabs__headers");
        tabs.style.display = "flex";

        const printLogo = document.getElementById("print-logo");
        printLogo.style.display = "none";
      });
    },
  },
  mounted() {
    this.StartApp();
    this.setupPrintListener();
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/layouts/default.scss";
@page {
  size: auto; /* auto is the initial value */
  margin: 0; /* this affects the margin in the printer settings */
}
#print-logo {
  display: none;
}
</style>
